export const TOPUP_OPTIONS = [
  { amountInCents: 4000, credits: 1000 },
  { amountInCents: 8000, credits: 2000 },
  { amountInCents: 12000, credits: 3000 },
  { amountInCents: 16000, credits: 4000 },
  { amountInCents: 20000, credits: 5000 },
];
